import { useEffect, } from "react";
import { create, } from 'zustand';

import { createBarsSlice, } from './bars';
import { createPlatformSlice, } from './platform';
import { createPricingSlice, } from './pricing';
import { createSettingsSlice, } from './settings';
import { createUISlice, } from './ui';
import { createVaultsSlice, } from './vaults/slice';
import { createWalletSlice,} from './wallet/slice';
import { createSwapSlice, } from './swap/slice';
import { createNotificationsSlice, } from './notifications/slice';
import { createMessagesSlice, } from './messages/slice';
import { createReferralsSlice,  } from './referrals/slice';
// import { createEscrowSlice, } from './escrow/slice';
import { createWrapSlice, } from './wrap/slice';

import type { VaultSymbol, } from "@bracket/types";
import type { VaultSection, } from "@bracket/platform/types";

export declare type Store = {
	bars: ReturnType<typeof createBarsSlice>;
	vaults: ReturnType<typeof createVaultsSlice>;
	wallet: ReturnType<typeof createWalletSlice>;
	platform: ReturnType<typeof createPlatformSlice>;
	ui: ReturnType<typeof createUISlice>;
	swap: ReturnType<typeof createSwapSlice>;
	notificationSlice: ReturnType<typeof createNotificationsSlice>;
	msg: ReturnType<typeof createMessagesSlice>;
	settings: ReturnType<typeof createSettingsSlice>;
	pricing: ReturnType<typeof createPricingSlice>;
	referrals: ReturnType<typeof createReferralsSlice>;
	// escrow: ReturnType<typeof createEscrowSlice>;
	wrap: ReturnType<typeof createWrapSlice>;
}


export const useStore = create<Store>((...a) => {
	return {
		// escrow: createEscrowSlice(...a),
		wallet: createWalletSlice(...a),
		vaults: createVaultsSlice(...a),
		bars: createBarsSlice(...a),
		platform: createPlatformSlice(...a),
		swap: createSwapSlice(...a),
		notificationSlice: createNotificationsSlice(...a),
		msg: createMessagesSlice(...a),
		settings: createSettingsSlice(...a),
		pricing: createPricingSlice(...a),
		ui: createUISlice(...a),
		referrals: createReferralsSlice(...a),
		wrap: createWrapSlice(...a),
	}
});



// export const useBars = () => useStore(state => state.bars);
export const useVaults = ({ vault, section, }: { vault?: VaultSymbol; section?: VaultSection; } = {}) => {
	const vaults = useStore(state => state.vaults);

	useEffect(() => {
		if(!vault || !vaults.ready || !vaults.available.length) {
			return;
		}

		if(vaults.active?.symbol !== vault) {
			void vaults.setActiveVault(vault, section);
			return;
		}

		if(section && vaults.activeSection !== section) {
			vaults.setActiveSection(section);
		}
	}, [vault, section, vaults.ready, vaults.available.length, vaults.active?.symbol, vaults.activeSection, vaults.setActiveSection, vaults.setActiveVault]);

	return vaults;
};
export const useWallet = () => useStore(state => state.wallet);
export const usePlatform = () => useStore(state => state.platform);
export const useAddNotification = () => useStore((state) => state.notificationSlice.addNotification);
export const useRemoveNotification = () => useStore((state) => state.notificationSlice.removeNotification);
export const useMessages = () => useStore(state => state.msg);
export const useMessaging = () => useStore(state => state.msg);
export const useSettings = () => useStore(state => state.settings);
export const usePricing = () => useStore(state => state.pricing);
export const useUI = () => useStore(state => state.ui);
export const useBars = () => useStore(state => state.bars);
export const useSwap = () => useStore(state => state.swap);
export const useBarsPoints = () => useStore(state => state.bars.points);
export const useBarsLeaderboard = () => useStore(state => state.bars.leaderboard);
export const useWalletPoints = () => useStore(state => state.bars.walletPoints);
export const useNotificationsStore = () => useStore(state => state.notificationSlice);
export const useWalletReferrals = () => useStore(state => state.referrals.walletReferrals);
export const useWalletRefId = () => useStore(state => state.referrals.walletRefId);
// export const useEscrow = () => useStore(state => state.escrow);
export const useWrap = () => useStore(state => state.wrap);

export type { IPlatformSlice, } from './platform';
export type { IVaultsSlice, } from './vaults';
export type { IWalletSlice, } from './wallet';

export * from "./messages";
